import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';

type FormGridColumns = 2 | 3 | 4;

const GRID_CLASS: Record<FormGridColumns, string> = {
  2: 'form-grid-2',
  3: 'form-grid-3',
  4: 'form-grid-4',
};

interface FormGridProps {
  children: ReactNode;
  /** Max columns on large screens — always 1 column on mobile, 2 on tablet. */
  columns?: FormGridColumns;
  className?: string;
}

/** Responsive form field layout: 1 col mobile · 2 tablet · 3–4 laptop. */
export function FormGrid({ children, columns = 4, className }: FormGridProps) {
  return <div className={cn(GRID_CLASS[columns], className)}>{children}</div>;
}
